import styled from 'styled-components';

const StyledMain = styled.main`
  margin-top: 17px;

  & .banner {
    margin-top: 92px;
    margin-bottom: 98px;
  }
`;

export default StyledMain;
